import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { hasRoleAgent } from 'common/userRoles';
import getLastPageVisitedByScreenIdList from 'common/util/getLastPageVisitedByScreenIdList';
import { getUpcomingTour } from 'common/tourHelpers';

import {
  SCREEN_ID_LISTING,
  SCREEN_ID_LISTINGS,
  SCREEN_ID_TOURS,
  SCREEN_ID_LISTINGS_MAP,
  SCREEN_ID_BOOKMARKS,
  SCREEN_ID_ADDRESS_SEARCH,
  SCREEN_ID_AGENT_TOURS,
  SCREEN_ID_AGENT_MAP,
  SCREEN_ID_FEED,
  SCREEN_ID_FEED_CATEGORY_MAP,
  SCREEN_ID_FEED_CATEGORY,
  SCREEN_ID_APARTMENT_LOCATOR_LEAD_ACTIVITY,
  SCREEN_ID_APARTMENT_LOCATOR_FEED,
  SCREEN_ID_PARTNER_OVERVIEW,
  SCREEN_ID_APARTMENT,
} from 'client/constants/screenIds';

import log from 'client/lib/log';
import branch from 'client/core/branch';
import Navigator from 'client/actions/Navigator';

const screenIdList = [
  SCREEN_ID_LISTINGS,
  SCREEN_ID_LISTINGS_MAP,
  SCREEN_ID_FEED_CATEGORY_MAP,
  SCREEN_ID_FEED_CATEGORY,
  SCREEN_ID_FEED,
  SCREEN_ID_BOOKMARKS,
  SCREEN_ID_ADDRESS_SEARCH,
  SCREEN_ID_AGENT_TOURS,
  SCREEN_ID_AGENT_MAP,
  SCREEN_ID_TOURS,
  SCREEN_ID_APARTMENT_LOCATOR_FEED,
  SCREEN_ID_APARTMENT_LOCATOR_LEAD_ACTIVITY,
  SCREEN_ID_PARTNER_OVERVIEW,
  SCREEN_ID_APARTMENT,
];

@branch({
  tours: ['tours'],
  listing: ['listing'],
  screenId: ['analytics', 'screenId'],
  screenIdHistory: ['analytics', 'screenIdHistory'],
  pathHistory: ['analytics', 'pathHistory'],
  currentUserRoles: ['currentUser', 'roles'],
})
class SrListingBackButton extends Component {
  static propTypes = {
    tours: PropTypes.array,
    listing: PropTypes.object,
    screenId: PropTypes.string.isRequired,
    screenIdHistory: PropTypes.array.isRequired,
    pathHistory: PropTypes.array.isRequired,
    isTransitioning: PropTypes.bool.isRequired,
  };

  componentDidMount(prevProps) {
    const { screenId, isTransitioning } = this.props;
    if (screenId !== SCREEN_ID_LISTING && !isTransitioning && prevProps.isTransitioning) {
      const error = new Error('SrListingBackButton can only be used in the listing page.');
      error.name = 'SrListingBackLinkUnsupportedScreenIdError';
      error.details = {
        screenId,
      };
      log.error(error);
    }
  }

  _goBack = () => {
    const { listing, tours, screenIdHistory, pathHistory, dispatch, currentUserRoles } = this.props;

    const lastPageVisited = getLastPageVisitedByScreenIdList({
      screenIdHistory,
      pathHistory,
      screenIdList,
    });

    let lastPageHref = '/feed';

    if (lastPageVisited) {
      lastPageHref = lastPageVisited.path;
    } else if (hasRoleAgent(currentUserRoles)) {
      lastPageHref = '/agent/tours';
    } else if (listing && tours) {
      const upcomingTour = getUpcomingTour(tours);
      const listingIdsScheduled = upcomingTour
        ? upcomingTour.listings.map((listing) => listing.id)
        : [];
      lastPageHref = listingIdsScheduled.includes(listing.id) ? '/tour' : '/feed';
    }

    dispatch(Navigator.setShouldRestoreScrollPosition);

    dispatch(Navigator.replace, {
      to: lastPageHref,
    });
  };

  render() {
    return (
      <a onClick={this._goBack} className="link back">
        Back
      </a>
    );
  }
}

SrListingBackButton.displayName = 'SrListingBackButton';

export default SrListingBackButton;
